// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-success-container{
    border-left: 8px solid #00762A;
    border-radius:8px;
}
.toast-error-container{
    border-left: 8px solid #CE121F;
    border-radius:8px;
}
.toast-warning-container{
    border-left: 8px solid #F1B434;
    border-radius:8px;
}
.toast-msg{
    font-family: 'Avenir';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    padding-top: 4px;
    padding-left: 4px;
}
.toast-close-btn{
    padding-top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/index.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".toast-success-container{\n    border-left: 8px solid #00762A;\n    border-radius:8px;\n}\n.toast-error-container{\n    border-left: 8px solid #CE121F;\n    border-radius:8px;\n}\n.toast-warning-container{\n    border-left: 8px solid #F1B434;\n    border-radius:8px;\n}\n.toast-msg{\n    font-family: 'Avenir';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    padding-top: 4px;\n    padding-left: 4px;\n}\n.toast-close-btn{\n    padding-top: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
